<div class="container">
  <div class="content">
    <div class="center-column">
      <img class="nowaccount-logo" alt="NowAccount Logo" />
      <h1>{{ this.headerText }}</h1>
      <p class="subHeaderText">{{ this.subheaderText }}</p>
      <app-serverside-alert></app-serverside-alert>
      <ng-container [formGroup]="this.form">
        <app-kendo-masked-textbox
          inputText="{{ this.phoneText }}"
          formControlName="phoneNumber"
          inputType="text"
          [parentForm]="form"
        ></app-kendo-masked-textbox>
        <div
          *ngIf="
            this.form.get('phoneNumber')?.invalid &&
            (this.form.get('phoneNumber')?.dirty ||
              this.form.get('phoneNumber')?.touched)
          "
          class="invalid-feedback"
        >
          <div
            *ngIf="this.form.get('phoneNumber')?.invalid && this.form.get('phoneNumber')?.errors?.['required']"
          >
            Phone Number is required.
          </div>
        </div>
        <div class="button-wrapper">
          <app-primary-button
            text="{{ this.phonebtnTxt }}"
            href=""
            [clickEvent]="this.sendPhoneCode.bind(this)"
          >
          </app-primary-button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
